import useBrandContext from 'Contexts/brand-context';
import Description from 'Shared/components/description';
import TextLink from 'Shared/components/text-link';
import InlineSvg from 'Shared/components/inline-svg';
import { useTranslation } from 'Shared/util/custom-hooks';
import styles from './introduction-section.css';


const renderPointItem = (text) => (
  <div className={styles.pointContainer}>
    <InlineSvg src="/check-mark.svg" />
    <div className={styles.pointText}>{text}</div>
  </div>
);


const IntroductionSection = () => {
  const { brandData, loadingBrandData } = useBrandContext();
  const t = useTranslation(x => x.acconomy);
  const tg = useTranslation(x => x.global);

  if (loadingBrandData) return null;

  const readableBrandName = brandData.name.replace(/([A-Z])/g, ' $1').trim();
  const acconomyUrl = `https://acconomy.com/${brandData.name.toLowerCase()}`;

  return (
    <div className={styles.container}>
      <img src="/integration/acconomy-macbook-and-iphone.png" alt="acconomy" />
      <div>
        <Description
          text={(
            <>
              <span>{`${t.format(t.introduction, { brandName: readableBrandName })} `}</span>
              <TextLink
                text={tg.readMore}
                link={acconomyUrl}
                className={styles.readMore}
              />
            </>
          )}
          className={styles.descriptionContainer}
        />
        <div className={styles.pointsContainer}>
          <div className={styles.pointSection}>
            {renderPointItem(t.invoicing)}
            {renderPointItem(t.completeAccounting)}
            {renderPointItem(t.sellTheInvoiceImmediatly)}
          </div>
          <div className={styles.pointSection}>
            {renderPointItem(t.no_administration_fees)}
            {renderPointItem(t.everythingInOnePlace)}
            {renderPointItem(t.completelyFreeOfCharge)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntroductionSection;
